import { Col, notification, Space, Typography } from "antd";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { RenderTitle } from "../../../engine/AuthRoute/navigationHelper";
import LogHistory from "../LogHistory";
import { useDispatch, useSelector } from "react-redux";
import { roles } from "../../../utils/constants";
import { ActionRoleSpecific } from "../../../engine/AuthRoute";
import { ActionDropdown } from "../ActionDropdown/ActionDropdown";
import { isSuperAdmin } from "../../../engine/hooks/hooks.helpers";
import { RiDeleteBinLine } from "react-icons/ri";
import {
  confirmDeleteInstitution,
  confirmFinalInstitutionDelete,
} from "../Modals/modals";
import { http } from "../../../engine/api/http";
import routes from "../../../engine/routes";
import { deleteInstitution } from "../../../pages/Institutions/Slices/Institution.slice";
import { useTranslation } from "react-i18next";

export const InstitutionHeader = ({ title }) => {
  const { t } = useTranslation(); // Initialize useTranslation
  const { loading, institution } = useSelector(state => state.institution);
  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const superAdmin = isSuperAdmin();

  const deleteInstitutionPanel = async () => {
    const res = await http.get("/institutions/" + id + "/deleteStatus");

    confirmDeleteInstitution({
      onOk: () => {
        confirmFinalInstitutionDelete({
          onOk: async () => {
            await dispatch(deleteInstitution(id));
            notification.success({
              message: t("institutionHeader.institutionDeleted"),
            });

            navigate(routes.institutions().list.path);
          },
          institution,
        });
      },
      props: res.data,
    });
  };

  return (
    <Col span={24}>
      <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
        <LogHistory updateEndPoint={[loading]} />
      </ActionRoleSpecific>
      <Space
        style={{
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={3} className={""}>
          <RenderTitle title={title} />
        </Typography.Title>
        {superAdmin && (
          <ActionDropdown loading={loading}>
            <a onClick={deleteInstitutionPanel} key={"deletePres"}>
              <span style={{ marginLeft: 5, marginRight: 10 }}>
                <RiDeleteBinLine size={18} color={"red"} />
              </span>
              {t("institutionHeader.deleteInstitution")}
            </a>
          </ActionDropdown>
        )}
      </Space>
    </Col>
  );
};
